import { getInitialInstituteId } from '../../../services/initialInstituteService';

export default {
    requestPoolPending: false,
    pendingJobMessage: null,
    instituteId: getInitialInstituteId(),
    zorgmailAccountId: null,
};
